import {
  IonCardHeader,
  IonCardSubtitle,
  IonCardTitle,
  IonCol,
  IonGrid,
  IonImg,
  IonRow,
  IonSlide,
  IonSlides,
} from '@ionic/react';
import React from 'react';
import IBHipExtensionTerminalSwing from './assets/IBHipExtensionTerminalSwing.png';
import './modalindex.css';

const slideOpts = {
  initialSlide: 0,
  speed: 400,
  direction: 'vertical',
};

export const ModalHipExtensionTerminalSwing = () => {
  return (
    <>
      <IonCardHeader className='reportInfoModal_Header'>
        <div>
          <IonCardTitle className='reportInfoModal_Title'>Hip extension</IonCardTitle>
          <IonCardSubtitle className='reportInfoModal_Subtitle'>Terminal Swing</IonCardSubtitle>
        </div>
      </IonCardHeader>

      <IonSlides pager={false} options={slideOpts} mode='ios'>
        <IonSlide>
          <IonGrid>
            <IonRow class='ion-align-items-center'>
              <IonCol size='12' size-lg='7' size-xl='7'>
                <div>
                  <IonImg src={IBHipExtensionTerminalSwing} class='reportInfoModal_Avatar' />
                </div>
              </IonCol>
              <IonCol>
                <div>
                  After midswing the leg keeps extending by hip flexion and knee extension. At terminal swing the
                  direction of hip movement reverses (from flexion to extension) partly due to the eccentric acting
                  hamstrings.
                  <br></br>
                  <br></br>
                  This increases tension on muscles, preparing the hip and knee for processing the ground reacting
                  forces which occur after initial contact and the accomplishment of a good balance.
                  <br></br>
                  <br></br>
                  When maximum hip flexion is not reached until initial contact, there will be lack of protecting
                  pre-tension. The shock absorbing mechanism will not be able to function optimally, increasing the
                  impact on joints significantly.
                  <br></br>
                  <br></br>
                  The cause of a compromised timed hip flexion can be found in either leg:
                  <ol type='A'>
                    <li>The swing is too slow and or hip ROM to low due to a weak push off</li>
                    <li>
                      Lack of time and being forced to land early due to instability and or control in the opposite leg
                      (being in terminal stance)
                    </li>
                  </ol>
                </div>
              </IonCol>
            </IonRow>
          </IonGrid>
        </IonSlide>
      </IonSlides>
    </>
  );
};
